import React from 'react';
import { Icons } from '../components/Icons';

const AnalyticsView = ({ data }) => {
    const activeUsers = (data.users || []).filter(u => u.status !== 'PENDING');
    const totalSleuths = activeUsers.filter(u => u.clearance === 'FIELD OP' || u.clearance === 'LEVEL 0').length;
    const totalAdmins = activeUsers.filter(u => u.clearance !== 'FIELD OP' && u.clearance !== 'LEVEL 0').length;
    
    const totalArtifacts = (data.artifacts || []).length;
    const totalLore = (data.ideas || []).length;
    
    const globalUnlocks = (data.users || []).reduce((sum, u) => sum + (u.unlocked ? u.unlocked.length : 0), 0);

    return (
        <div className="flex-1 overflow-y-auto p-6 bg-[#050505] custom-scrollbar fade-in">
            <h2 className="text-xl font-bold flex items-center gap-2 text-white mb-8 border-b border-gray-900 pb-4 font-sans tracking-tight">
                <Icons.BarChart className="text-emerald-500" /> SYSTEM ANALYTICS
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
                <div className="bg-[#0a0a0a] border border-gray-800 p-6 rounded relative overflow-hidden group hover:border-emerald-500/50 transition-colors">
                    <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity"><Icons.Eye size={64}/></div>
                    <h3 className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2 relative z-10">Registered Sleuths</h3>
                    <div className="text-4xl font-black text-white relative z-10">{totalSleuths}</div>
                </div>

                <div className="bg-[#0a0a0a] border border-gray-800 p-6 rounded relative overflow-hidden group hover:border-emerald-500/50 transition-colors">
                    <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity"><Icons.Unlock size={64}/></div>
                    <h3 className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2 relative z-10">Total Anomalies Secured</h3>
                    <div className="text-4xl font-black text-[#00ff41] drop-shadow-[0_0_10px_rgba(0,255,65,0.4)] relative z-10">{globalUnlocks}</div>
                </div>

                <div className="bg-[#0a0a0a] border border-gray-800 p-6 rounded relative overflow-hidden group hover:border-emerald-500/50 transition-colors">
                    <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity"><Icons.Database size={64}/></div>
                    <h3 className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2 relative z-10">Active Thresholds</h3>
                    <div className="text-4xl font-black text-white relative z-10">{totalArtifacts}</div>
                </div>

                <div className="bg-[#0a0a0a] border border-gray-800 p-6 rounded relative overflow-hidden group hover:border-emerald-500/50 transition-colors">
                    <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity"><Icons.BookOpen size={64}/></div>
                    <h3 className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2 relative z-10">Lore & Concepts Logged</h3>
                    <div className="text-4xl font-black text-white relative z-10">{totalLore}</div>
                </div>
            </div>

            <div className="bg-[#0a0a0a] border border-gray-800 p-6 rounded">
                <h3 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-6">Database Health</h3>
                <div className="space-y-4">
                    <div>
                        <div className="flex justify-between text-xs mb-2">
                            <span className="text-gray-400">Hub Administrators</span>
                            <span className="text-white font-bold">{totalAdmins}</span>
                        </div>
                        <div className="w-full bg-gray-900 h-1.5 rounded overflow-hidden">
                            <div className="bg-cyan-500 h-full" style={{width: `${Math.min((totalAdmins/10)*100, 100)}%`}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsView;